export const getFeed = state => state.feed.feedPostsIds;
export const feedCursor = state => state.feed.cursor;
export const feedAnchorPosition = state => state.feed.feedAnchorPosition;
export const getAnnouncementId = state => state.feed.announcementId;
export const isPostAdded = state => state.feed.isPostAdded;
export const isConfirmedAnnouncementPopover = state => state.feed.isConfirmedAnnouncementPopover;
